import React, {useEffect} from 'react';
import PageHeader from '../components/PageHeader.jsx';
import '../styles/fonts.css';

const Attributions = () => {
    let sampleImg = 'https://static.igem.wiki/teams/5066/global/bgpic.png';

    useEffect(() => {
      function listenToIframeHeight(e) {
        if (e.origin === "https://teams.igem.org") {
          const { type, data } = JSON.parse(e.data);
          if (type === "igem-attribution-form") {
            const element = document.getElementById("igem-attribution-form");
            if (element) {
              element.style.height = `${data + 50}px`;
            }
          }
        }
      }
      window.addEventListener("message", listenToIframeHeight);
      return () => {
        window.removeEventListener("message", listenToIframeHeight);
      };
    }, []);


    return (
      <div>
        <div className='bg-[#d9eaf0]'>
            <PageHeader img={sampleImg} title='Attributions' />
        </div>

        <div className='flex'>
          <iframe
            title={"Attributions"}
            style={{width: "100%"}}
            id="igem-attribution-form"
            src={`https://teams.igem.org/wiki/5066/attributions`}
          />
        </div>
      </div>
    );
};

export default Attributions;